//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import {
  HttpClient,
  HttpContext,
  HttpHeaders,
  HttpResponse,
  HttpResponseBase,
} from '@angular/common/http';
import { Injectable, InjectionToken, inject } from '@angular/core';
import {
  Observable,
  from as _observableFrom,
  of as _observableOf,
  throwError as _observableThrow,
} from 'rxjs';
import { catchError as _observableCatch, mergeMap as _observableMergeMap } from 'rxjs/operators';
import { UsertStore } from '../context/userStore';
import { GATEWAY_API_BASE_URL } from './mhsGatewayApiTokens';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable({
  providedIn: 'root',
})
export class MhsAiToolsApiClient {
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;
  private http = inject(HttpClient);
  private userStore = inject(UsertStore);
  private baseUrl = inject(GATEWAY_API_BASE_URL, { optional: true });
  protected transformOptions(options: any): Promise<any> {
    options.headers = options.headers.append(
      'tenant-name',
      this.userStore.currentTenant()?.tenantName,
    );
    return Promise.resolve(options);
  }
  /**
   * Receive Procedures
   * @return Successful Response
   */
  receive_procedures_api_ai_tools_context_procedure_set_generate_names_post(
    body: Procedure[],
    httpContext?: HttpContext,
  ): Observable<GenerateResponse> {
    let url_ = this.baseUrl + '/gateway/ai-tools/context/procedure-set/generate-names';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processReceive_procedures_api_ai_tools_context_procedure_set_generate_names_post(
            response_,
          );
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processReceive_procedures_api_ai_tools_context_procedure_set_generate_names_post(
                response_ as any,
              );
            } catch (e) {
              return _observableThrow(e) as any as Observable<GenerateResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<GenerateResponse>;
        }),
      );
  }

  protected processReceive_procedures_api_ai_tools_context_procedure_set_generate_names_post(
    response: HttpResponseBase,
  ): Observable<GenerateResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = GenerateResponse.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status === 422) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result422: any = null;
          let resultData422 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result422 = HTTPValidationError.fromJS(resultData422);
          return throwException('Validation Error', status, _responseText, _headers, result422);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
}

export class GenerateResponse implements IGenerateResponse {
  isValid!: boolean;
  type!: string;
  suggestions!: Suggestion[];
  message!: string;

  [key: string]: any;

  constructor(data?: IGenerateResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.suggestions = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property)) this[property] = _data[property];
      }
      this.isValid = _data['isValid'];
      this.type = _data['type'];
      if (Array.isArray(_data['suggestions'])) {
        this.suggestions = [] as any;
        for (let item of _data['suggestions']) this.suggestions!.push(Suggestion.fromJS(item));
      }
      this.message = _data['message'];
    }
  }

  static fromJS(data: any): GenerateResponse {
    data = typeof data === 'object' ? data : {};
    let result = new GenerateResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property)) data[property] = this[property];
    }
    data['isValid'] = this.isValid;
    data['type'] = this.type;
    if (Array.isArray(this.suggestions)) {
      data['suggestions'] = [];
      for (let item of this.suggestions)
        data['suggestions'].push(item ? item.toJSON() : (undefined as any));
    }
    data['message'] = this.message;
    return data;
  }
}

export interface IGenerateResponse {
  isValid: boolean;
  type: string;
  suggestions: Suggestion[];
  message: string;

  [key: string]: any;
}

export class HTTPValidationError implements IHTTPValidationError {
  detail?: ValidationError[];

  [key: string]: any;

  constructor(data?: IHTTPValidationError) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property)) this[property] = _data[property];
      }
      if (Array.isArray(_data['detail'])) {
        this.detail = [] as any;
        for (let item of _data['detail']) this.detail!.push(ValidationError.fromJS(item));
      }
    }
  }

  static fromJS(data: any): HTTPValidationError {
    data = typeof data === 'object' ? data : {};
    let result = new HTTPValidationError();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property)) data[property] = this[property];
    }
    if (Array.isArray(this.detail)) {
      data['detail'] = [];
      for (let item of this.detail) data['detail'].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IHTTPValidationError {
  detail?: ValidationError[];

  [key: string]: any;
}

export class Procedure implements IProcedure {
  id!: string;
  name!: string;

  [key: string]: any;

  constructor(data?: IProcedure) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property)) this[property] = _data[property];
      }
      this.id = _data['id'];
      this.name = _data['name'];
    }
  }

  static fromJS(data: any): Procedure {
    data = typeof data === 'object' ? data : {};
    let result = new Procedure();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property)) data[property] = this[property];
    }
    data['id'] = this.id;
    data['name'] = this.name;
    return data;
  }
}

export interface IProcedure {
  id: string;
  name: string;

  [key: string]: any;
}

export class Suggestion implements ISuggestion {
  name!: string;
  best!: boolean;

  [key: string]: any;

  constructor(data?: ISuggestion) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property)) this[property] = _data[property];
      }
      this.name = _data['name'];
      this.best = _data['best'];
    }
  }

  static fromJS(data: any): Suggestion {
    data = typeof data === 'object' ? data : {};
    let result = new Suggestion();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property)) data[property] = this[property];
    }
    data['name'] = this.name;
    data['best'] = this.best;
    return data;
  }
}

export interface ISuggestion {
  name: string;
  best: boolean;

  [key: string]: any;
}

export class ValidationError implements IValidationError {
  loc!: Loc[];
  msg!: string;
  type!: string;

  [key: string]: any;

  constructor(data?: IValidationError) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.loc = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property)) this[property] = _data[property];
      }
      if (Array.isArray(_data['loc'])) {
        this.loc = [] as any;
        for (let item of _data['loc']) this.loc!.push(item);
      }
      this.msg = _data['msg'];
      this.type = _data['type'];
    }
  }

  static fromJS(data: any): ValidationError {
    data = typeof data === 'object' ? data : {};
    let result = new ValidationError();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property)) data[property] = this[property];
    }
    if (Array.isArray(this.loc)) {
      data['loc'] = [];
      for (let item of this.loc) data['loc'].push(item);
    }
    data['msg'] = this.msg;
    data['type'] = this.type;
    return data;
  }
}

export interface IValidationError {
  loc: Loc[];
  msg: string;
  type: string;

  [key: string]: any;
}

export class Loc implements ILoc {
  [key: string]: any;

  constructor(data?: ILoc) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property)) this[property] = _data[property];
      }
    }
  }

  static fromJS(data: any): Loc {
    data = typeof data === 'object' ? data : {};
    let result = new Loc();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property)) data[property] = this[property];
    }
    return data;
  }
}

export interface ILoc {
  [key: string]: any;
}

export class ApiException extends Error {
  override message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result: any,
  ) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any,
): Observable<any> {
  if (result !== null && result !== undefined) return _observableThrow(result);
  else return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
  return new Observable<string>((observer: any) => {
    if (!blob) {
      observer.next('');
      observer.complete();
    } else {
      let reader = new FileReader();
      reader.onload = (event) => {
        observer.next((event.target as any).result);
        observer.complete();
      };
      reader.readAsText(blob);
    }
  });
}
